import React, {useEffect} from 'react';
import WaitSpinner from '../../../../components/wait-spinner';
import { isoTimestampToUk, asMoney } from '../../../../utils';
import {useLocation, Link, useParams, useOutletContext} from 'react-router-dom';
import {useGetChangeDetailQueryQuery, useGetChangesQueryQuery} from "../../../../generated/graphql";
import {NonIdealState} from "../../../../components/NonIdealState";
import {CampaignOutletContextValue} from "../../form";
import {CampaignChangesContainer, CampaignChangesTable} from "./index";
import { useExchangeRatesContext } from '../../../../contexts/exchange-rates-context';


export const CampaignChangesPane = () => {
    let changeDetail;
    const { values,setTab} = useOutletContext<CampaignOutletContextValue>();
    const location = useLocation();
    const params = useParams();
    const currency = useExchangeRatesContext();
    const changeId = params.subId;
    const makeUrl = (id)=>{
        return '/campaigns/'+values.job_reference+'/changes/'+id+(location.search?location.search:'');
    }
    useEffect(()=>{
        setTab('changes');
    },[]);

    const { data, loading, error } = useGetChangesQueryQuery({
        variables: {
            tracked_id: values?.id,
            tracked_type: 'Campaign'
        },
        skip: !values?.id,
        fetchPolicy: "network-only"
    });
    const changes = useGetChangeDetailQueryQuery({
        variables: {
            tracked_id: values?.id,
            tracked_type: 'Campaign',
            change_id: changeId
        },
        skip: !changeId,
        fetchPolicy: "network-only"
    });
    if (loading || values?.id == 'new') {
        return <WaitSpinner variant="overlay" />;
    }
    if (error) {
        return <NonIdealState title="An error has occurred"/>;
    }
    const records = data?.getChangesForRecord?.data;
    if (!records && !records.length) {
        return <div>No changelog</div>
    }
    const content = records.map(
        (k) => {
            let keyFields;
            if (k.key_fields) {
                keyFields = JSON.parse(k.key_fields);
            } else {
                keyFields = {};
            }
            return (<tr key={k.id} className={k.id==changeId?'active':''}>
                <td><Link to={makeUrl(k.id)}>
                    {isoTimestampToUk(k.created_at)}
                    </Link>
                </td>
                <td>
                    {k.short_summary}
                </td>
                <td>
                    {(currency?.targetCurrency?.glyph??'')+asMoney(keyFields?.total_price)}
                </td>
                <td>{keyFields.status}</td>
            </tr>);
        }
    );
    if(changeId) {
        if(changes.loading) {
            changeDetail = <WaitSpinner variant="panel"/>;
        } else {
            if(changes.error) {
                changeDetail = <NonIdealState severity="error" title="A problem has occurred"/>;
            } else {
                const changeRows = JSON.parse(changes.data?.getChangeDetail?.details);
                changeDetail = <CampaignChangesTable className={['table'].join(' ')}>
                    <thead>
                    <tr><th>Field</th><th>Old</th><th>New</th></tr>
                    </thead>
                    {changeRows.map((row,idx)=>(
                    <tbody key={idx}>
                        {row.name&&<tr className="change-header"><td colSpan={3}>{row.name}</td></tr>}
                        {row.changes.map((k,id)=><tr className="change-row" key={id}><td>{k[0]}</td><td>{k[1]}</td><td>{k[2]}</td></tr>)}
                    </tbody>
                    ))}
                    </CampaignChangesTable>;
                }
            }
    } else {
        changeDetail = <div></div>;
    }
    return (
        <CampaignChangesContainer className="grid12 is-scrollable">
            <div className="grid12-5 is-scrollable">
                <CampaignChangesTable className={['table'].join(' ')}>
                    <thead>
                    <tr>
                        <th>Time/Date</th>
                        <th>Summary</th>
                        <th>Total</th>
                        <th>Status</th>
                    </tr>
                    </thead>
                    <tbody>
                        {content}
                    </tbody>
                </CampaignChangesTable>
            </div>
            <div className="grid12-7 is-scrollable">
                {changeDetail}
            </div>
        </CampaignChangesContainer>);
};

